/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable max-len */
import { motion } from 'framer-motion';
import React, { useState, useEffect, useCallback } from 'react';
import AppliedOfferToolTip from '../AppliedOfferToolTip/Index';
// import AppliedOfferToolTip from '../../../../Components/AppliedOfferToolTip';

export default function CommonSummary({
    type, Calculation, orderFlow, GetCalculation, OrderDetails,
}) {
    const handleAmount = (value) => Number(value)?.toLocaleString('en-IN', {
        style: 'currency',
        currency: 'INR',
    });
    const [adorCashCheck, setadorCashCheck] = useState(false);
    const adorCashUsed = Number(OrderDetails?.ador_cash_used) > 0;
    const [appliedOfferHover, setappliedOfferHover] = useState('');
    // const getCalculation = useCallback(
    //     () => {
    //         GetCalculation();
    //     },
    //     [orderFlow],
    // );

    // useEffect(() => {
    //     getCalculation();
    // }, [getCalculation]);
    return (
        <motion.div
            animate={{ opacity: 1, y: 0 }}
            initial={{ opacity: 0, y: 20 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.15 }}
        >
            <div className="py-1 border-b border-[#CBCBCB] sm:pr-1 sm:pl-2">
                <div className="flex justify-between items-center sm:mt-0 mt-1">
                    <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Order value</p>
                    <p className="sm:text-lg text-base font-semibold text-[#555259]">
                        {
                            handleAmount(Calculation?.order_value)
                        }

                    </p>
                </div>
                <div className="flex justify-between items-center sm:mt-0 mt-1">
                    <p className="sm:text-xs18 text-sm text-[#555259] font-normal">
                        Discount
                        <span className="ml-1">
                            <button
                                onMouseEnter={() => {
                                    setTimeout(() => {
                                        setappliedOfferHover('active');
                                    }, 2000);
                                }}
                                onMouseLeave={() => {
                                    setTimeout(() => {
                                        setappliedOfferHover('');
                                    }, 3000);
                                }}
                                data-tooltip-target="tooltip-discountPercentage1"
                                data-tooltip-placement="right"
                                data-tooltip-trigger="click"
                                type="button"
                            >
                                <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer" />
                            </button>
                            {appliedOfferHover !== '' && (
                                <AppliedOfferToolTip hover={appliedOfferHover !== ''} prod={Calculation} />
                            )}
                        </span>

                    </p>

                    <p className="sm:text-lg text-base font-semibold text-[#555259]">
                        {handleAmount(Calculation?.total_discount)}

                    </p>
                </div>
                {type
                && (
                    <div className="flex justify-between items-center sm:mt-0 mt-1">
                        <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Add. Discount</p>
                        <p className="sm:text-lg text-base font-semibold text-[#555259]">
                            {
                                handleAmount(Calculation?.proposed_additional_discount)
                            }
                        </p>
                    </div>
                )}
                <div className="flex justify-between items-center sm:mt-0 mt-1">
                    <p className="sm:text-xs18 text-sm text-[#555259] font-normal">DAP</p>
                    <p className="sm:text-lg text-base font-semibold text-[#555259]">
                        {handleAmount(Calculation?.dap_charges)}

                    </p>
                </div>
            </div>
            <div className="sm:pr-1 sm:pl-2">
                <div className="flex justify-between items-center mt-1.5">
                    <p className="sm:text-xs18 text-sm text-[#000000] font-normal">Sub Total</p>
                    <p className="sm:text-xs7 text-base font-semibold text-[#000000]">
                        {
                            type ? handleAmount(Calculation?.proposed_net_amount) : handleAmount(Calculation?.order_net_amount)
                        }

                    </p>
                </div>
                {/* {Number(Calculation?.order_avail_ador_cash) > 0 && (
                    <div className="relative checkbox custom-checkbox-offer flex items-center mt-1 mb-2.5">
                        <input
                            type="checkbox"
                            id="checkbox-1"
                            checked={adorCashCheck}
                            onChange={() => setadorCashCheck(!adorCashCheck)}
                            className="cursor-pointer"
                        />
                        <label htmlFor="checkbox-1" className="pl-2 text-sm font-normal text-[#000000] cursor-pointer">
                            Use Ador Cash (
                            {handleAmount(Number(type ? Calculation?.proposed_avail_ador_cash : Calculation?.order_avail_ador_cash))}
                            )
                        </label>
                    </div>
                )} */}
            </div>
            {adorCashUsed
            && (
                <div className="py-1 border-b border-t border-[#CBCBCB] sm:pr-1 sm:pl-2">
                    <div className="flex justify-between items-center sm:mt-0 mt-1">
                        <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Ador cash</p>
                        <p className="sm:text-lg text-base font-semibold text-[#555259]">
                            {OrderDetails?.order_type !== 'Trade'
                                ? (
                                    <>
                                        {adorCashUsed
                                            ? handleAmount(type ? Calculation?.proposed_avail_ador_cash : Calculation?.order_avail_ador_cash) : handleAmount(Calculation?.ador_cash_used)}
                                    </>
                                )
                                : (
                                    <>
                                        {adorCashUsed
                                            ? handleAmount(Calculation?.order_avail_ador_cash)
                                            : handleAmount(Calculation?.ador_cash_used)}
                                    </>
                                )}

                        </p>
                    </div>
                </div>
            )}
            <div className="py-1 border-b border-t border-[#CBCBCB] sm:pr-1 sm:pl-2">
                <div className="flex justify-between items-center sm:mt-0 mt-1">
                    <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Net Amount</p>
                    <p className="sm:text-lg text-base font-semibold text-[#555259]">
                        {type
                            ? (
                                <>
                                    {adorCashUsed
                                        ? handleAmount(Calculation?.ador_cash_proposed_net_amount) : handleAmount(Calculation?.proposed_net_amount)}
                                </>
                            )
                            : (
                                <>
                                    {adorCashUsed
                                        ? handleAmount(Calculation?.ador_cash_order_net_amount)
                                        : handleAmount(Calculation?.order_net_amount)}
                                </>
                            )}

                    </p>
                </div>
            </div>
            <div className="py-1 border-b border-t border-[#CBCBCB] sm:pr-1 sm:pl-2">
                <div className="flex justify-between items-center sm:mt-0 mt-1">
                    <p className="sm:text-xs18 text-sm text-[#555259] font-normal">
                        GST
                        {' '}
                        <span>(18%)</span>
                    </p>
                    <p className="sm:text-lg text-base font-semibold text-[#555259]">
                        {type
                            ? <>{adorCashUsed ? handleAmount(Calculation?.proposed_gst.ador_cash_avail_gst) : handleAmount(Calculation?.proposed_gst?.gst)}</>
                            : (
                                <>
                                    {adorCashUsed
                                        ? handleAmount(Calculation?.order_gst.ador_cash_avail_gst)
                                        : handleAmount(Calculation?.order_gst.gst)}
                                </>
                            )}

                    </p>
                </div>
            </div>
            <div className="sm:pr-1 sm:pl-2 border-b border-[#CBCBCB] py-1">
                <div className="flex justify-between items-center mt-1.5">
                    <p className="sm:text-xs18 text-sm text-[#000000] font-normal">Gross Amount</p>
                    <p className="smd:text-xs10 sm:text-lg text-base font-semibold text-[#000000]" data-testid="total-amt">
                        {type
                            ? <>{adorCashUsed ? handleAmount(Calculation?.ador_cash_proposed_gross_amount) : handleAmount(Calculation?.proposed_gross_amount)}</>
                            : (
                                <>
                                    {adorCashUsed
                                        ? handleAmount(Calculation?.ador_cash_order_gross_amount)
                                        : handleAmount(Calculation?.order_gross_amount)}
                                </>
                            )}
                    </p>
                </div>
            </div>
            <div className="pt-2">
                <p className="font-normal text-xs3 text-[#FF3B30] mt-1.5">
                    <span className="text-[#FF3B30]">*</span>
                    Taxes & Duties are subject to change as per Government guidelines and will be charged as applicable at the time of dispatch
                </p>

            </div>
        </motion.div>
    );
}
